// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fDifq-Content-module_root{padding-top:2.6666666667rem;padding-left:2.6666666667rem;padding-right:2.6666666667rem;padding-bottom:2rem}@media not (hover:hover){.beljo-Content-module_grow{display:flex;flex-direction:column;flex-grow:1}}.Ef6x2-Content-module_container{transition:height .3s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "fDifq-Content-module_root",
	"grow": "beljo-Content-module_grow",
	"container": "Ef6x2-Content-module_container"
};
export default ___CSS_LOADER_EXPORT___;
